import React from 'react';
import { PathStageChips } from './PathStageChips';
import { cn } from '../../lib/utils';

export function PathInsightPanel({ path, className }) {
  if (!path) return null;

  const shareLabel = `${(path.share * 100).toFixed(1)}%`;

  return (
    <aside
      className={cn(
        'rounded-xl bg-[var(--brand-primary,#1A428A)] px-4 py-4 text-white shadow-sm',
        className
      )}
    >
      <p className="font-display text-[10px] font-bold uppercase tracking-[0.14em] text-white/70">
        Selected path
      </p>
      <div className="mt-2.5">
        <PathStageChips
          stages={path.stages}
          className="[&_span]:bg-white/15 [&_span]:text-white [&_svg]:text-white/50"
        />
      </div>
      <p className="mt-2.5 text-sm font-semibold tabular-nums">
        {path.count.toLocaleString('en-US')} · {shareLabel}
      </p>
      {path.insight ? (
        <p className="mt-2 text-xs leading-snug text-white/90">{path.insight}</p>
      ) : null}
      {path.action ? (
        <div className="mt-3 border-t border-white/20 pt-3">
          <p className="font-display text-[10px] font-bold uppercase tracking-[0.12em] text-white/65">
            Do next
          </p>
          <p className="mt-1 text-xs leading-relaxed text-white">{path.action}</p>
        </div>
      ) : null}
    </aside>
  );
}
